import React from 'react';

export default function TeamPageBottom() {
  return (
    <div>
      <section className="team_page_bottom">
        <div className="house_bg" />
      </section>
    </div>
  );
}
